// extracted by mini-css-extract-plugin
export default {"hideTooltip":"r9-z","fadeIn":"s9-z","delay":"t9-z","recommendedSizeTooltip":"u9-z"};